import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import { EntityGroup } from "src/app/store/models/industry-page.model";

@Component({
  selector: "app-industry-market-cap-filter",
  templateUrl: "./industry-market-cap-filter.component.html",
  styleUrls: ["./industry-market-cap-filter.component.scss"],
})
export class IndustryMarketCapFilterComponent {
  @Input() marketCaps: Array<EntityGroup>;
  @Output() marketCapSelect: EventEmitter<Array<number>> = new EventEmitter();
  @Input() selectedMarketCaps: Array<number>;
  @Input() marketCapExpandedKeys: Array<number>;
  @Input() isMegaMenuReady: boolean;
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 4,
      },
    },
  };

  ngOnChanges() {
    if (this.marketCaps && this.marketCaps.length > 0) {
      this.marketCaps[0]["expanded"] = true;
    }
  }

  onCheckboxChange(data) {
    this.marketCapSelect.emit(data.keys);
  }
}
